import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Row } from 'react-bootstrap';
import Accordion from '../../../../components/Accordion';
import Blockquote from '../../../../components/Blockquote';
import Link from '../../../../components/Link';
import NumberInput from '../../../../components/NumberInput';

export type investMyselfSectionProps = {
  data: any;
  collectData: (data: any) => void;
};

const accordionsItemsData = [
  {
    title: 'Vanguard Target Retire 2060 Tr I',
    fundLink: '',
    oneYearReturn: '28.58%',
    threeYearsReturn: '12.76%',
    note: 'This is an age appropriate fund that adjusts risk over time for someone your age (age 25) retiring in 2060 at age 65)',
  },
  {
    title: 'Vanguard Target Retire 2030 Tr I',
    fundLink: '',
    oneYearReturn: '28.58%',
    threeYearsReturn: '12.76%',
    note: '',
  },
  {
    title: 'Vanguard Target Retire 2035 Tr I',
    fundLink: '',
    oneYearReturn: '28.58%',
    threeYearsReturn: '12.76%',
    note: '',
  },
  {
    title: 'Vanguard Target Retire 2040 Tr I',
    fundLink: '',
    oneYearReturn: '28.58%',
    threeYearsReturn: '12.76%',
    note: '',
  },
  {
    title: 'Vanguard Target Retire 2045 Tr I',
    fundLink: '',
    oneYearReturn: '28.58%',
    threeYearsReturn: '12.76%',
    note: '',
  },
];

const InvestMyself = ({ data, collectData }: investMyselfSectionProps) => {
  return (
    <section className="col-12 px-10 pt-11 pb-10 bg-white rounded-1">
      <Row className="m-0">
        <Col className="p-0 col-5 col-lg-6">
          <h6 className="fw-normal m-0">Adjust Elections</h6>
        </Col>
      </Row>
      <Row className="m-0 mt-7 pb-7">
        <Col className="p-0 col-5 col-lg-6 pe-3"> </Col>
        <Col className="p-0 px-3">
          <div className="text-light-grey-normal fw-normal text-sub1 lh-xxs">
            <span>1 Year Return</span>
          </div>
        </Col>
        <Col className="p-0 ps-3">
          <div className="text-light-grey-normal fw-normal text-sub1 lh-xxs">
            <span>3 Year Return</span>
          </div>
        </Col>
        <Col className="p-0 pe-3"> </Col>
      </Row>
      <Row className="mb-2">
        <Accordion
          title={'Target Date Funds'}
          subtitle={
            'These funds become more conservative as they get closer to the retirement year'
          }
          titlePercent={data.investMyself.targetDateFunds || '0'}
        >
          {accordionsItemsData.map((item, i) => (
            <>
              <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100 border-top">
                <Col className="p-0 ps-lg-13 col-5 col-lg-6 pe-3 d-lg-flex flex-lg-column justify-content-lg-center align-items-lg-start">
                  <h6 className="text-sub fw-normal m-0">{item.title}</h6>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    style={{ maxWidth: 100 }}
                  >
                    Fund Details
                  </Link>
                </Col>
                <Col className="p-0 px-3 px-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.oneYearReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 ps-3 ps-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.threeYearsReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 col-12 col-lg-2 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <NumberInput
                    placeholder={'0'}
                    defaultValue={0}
                    isPercent
                    minValue={'0'}
                    maxValue={'100'}
                  />
                </Col>
              </Row>
              {item.note && (
                <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100">
                  <Col className="p-0 ps-lg-13 pe-3">
                    <Blockquote>
                      <div className="fw-light text-sub1 text-light-grey-normal">
                        <span>{item.note}</span>
                      </div>
                    </Blockquote>
                  </Col>
                </Row>
              )}
            </>
          ))}
        </Accordion>
      </Row>
      <Row className="mb-2">
        <Accordion
          title={'Domestic Equity/Stock'}
          subtitle={
            'These funds typically have higher returns but increased risk'
          }
          titlePercent={data.investMyself.domestic || '0'}
        >
          {accordionsItemsData.slice(2).map((item, i) => (
            <>
              <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100 border-top">
                <Col className="p-0 ps-lg-13 col-5 col-lg-6 pe-3 d-lg-flex flex-lg-column justify-content-lg-center align-items-lg-start">
                  <h6 className="text-sub fw-normal m-0">{item.title}</h6>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    style={{ maxWidth: 100 }}
                  >
                    Fund Details
                  </Link>
                </Col>
                <Col className="p-0 px-3 px-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.oneYearReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 ps-3 ps-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.threeYearsReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 col-12 col-lg-2 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <NumberInput
                    placeholder={'0'}
                    value={0}
                    isPercent
                    minValue={'0'}
                    maxValue={'100'}
                  />
                </Col>
              </Row>
              {item.note && (
                <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100">
                  <Col className="p-0 ps-lg-13 pe-3">
                    <Blockquote>
                      <div className="fw-light text-sub1 text-light-grey-normal">
                        <span>{item.note}</span>
                      </div>
                    </Blockquote>
                  </Col>
                </Row>
              )}
            </>
          ))}
        </Accordion>
      </Row>
      <Row className="mb-2">
        <Accordion
          title={'International Equity/Stock'}
          subtitle={
            'These funds typically have higher returns but increased risk'
          }
          titlePercent={data.investMyself.international || '0'}
        >
          {accordionsItemsData.slice(2).map((item, i) => (
            <>
              <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100 border-top">
                <Col className="p-0 ps-lg-13 col-5 col-lg-6 pe-3 d-lg-flex flex-lg-column justify-content-lg-center align-items-lg-start">
                  <h6 className="text-sub fw-normal m-0">{item.title}</h6>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    style={{ maxWidth: 100 }}
                  >
                    Fund Details
                  </Link>
                </Col>
                <Col className="p-0 px-3 px-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.oneYearReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 ps-3 ps-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.threeYearsReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 col-12 col-lg-2 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <NumberInput
                    placeholder={'0'}
                    value={0}
                    isPercent
                    minValue={'0'}
                    maxValue={'100'}
                  />
                </Col>
              </Row>
              {item.note && (
                <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100">
                  <Col className="p-0 ps-lg-13 pe-3">
                    <Blockquote>
                      <div className="fw-light text-sub1 text-light-grey-normal">
                        <span>{item.note}</span>
                      </div>
                    </Blockquote>
                  </Col>
                </Row>
              )}
            </>
          ))}
        </Accordion>
      </Row>
      <Row className="mb-2">
        <Accordion
          title={'Bond/Fixed Income'}
          subtitle={
            'These funds typically have higher returns but increased risk'
          }
          titlePercent={data.investMyself.bondIncome || '0'}
        >
          {accordionsItemsData.slice(3).map((item, i) => (
            <>
              <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100 border-top">
                <Col className="p-0 ps-lg-13 col-5 col-lg-6 pe-3 d-lg-flex flex-lg-column justify-content-lg-center align-items-lg-start">
                  <h6 className="text-sub fw-normal m-0">{item.title}</h6>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    style={{ maxWidth: 100 }}
                  >
                    Fund Details
                  </Link>
                </Col>
                <Col className="p-0 px-3 px-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.oneYearReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 ps-3 ps-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.threeYearsReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 col-12 col-lg-2 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <NumberInput
                    placeholder={'0'}
                    value={0}
                    isPercent
                    minValue={'0'}
                    maxValue={'100'}
                  />
                </Col>
              </Row>
              {item.note && (
                <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100">
                  <Col className="p-0 ps-lg-13 pe-3">
                    <Blockquote>
                      <div className="fw-light text-sub1 text-light-grey-normal">
                        <span>{item.note}</span>
                      </div>
                    </Blockquote>
                  </Col>
                </Row>
              )}
            </>
          ))}
        </Accordion>
      </Row>
      <Row className="mb-2">
        <Accordion
          title={'Client Specific'}
          subtitle={
            'These funds typically have higher returns but increased risk'
          }
          titlePercent={data.investMyself.clientSpecific || '1'}
        >
          {accordionsItemsData.slice(4).map((item, i) => (
            <>
              <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100 border-top">
                <Col className="p-0 ps-lg-13 col-5 col-lg-6 pe-3 d-lg-flex flex-lg-column justify-content-lg-center align-items-lg-start">
                  <h6 className="text-sub fw-normal m-0">{item.title}</h6>
                  <Link
                    rightIcon={light('arrow-up-right-from-square')}
                    isBlue
                    isAlignAtEnd
                    style={{ maxWidth: 100 }}
                  >
                    Fund Details
                  </Link>
                </Col>
                <Col className="p-0 px-3 px-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.oneYearReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 ps-3 ps-lg-0 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <div className="fw-light text-sub1 lh-xxs">
                    <span>{item.threeYearsReturn}</span>
                  </div>
                </Col>
                <Col className="p-0 col-12 col-lg-2 d-lg-flex justify-content-lg-center align-items-lg-center">
                  <NumberInput
                    placeholder={'0'}
                    value={0}
                    isPercent
                    minValue={'0'}
                    maxValue={'100'}
                  />
                </Col>
              </Row>
              {item.note && (
                <Row className="m-0 py-7 px-7 px-lg-0 pe-lg-7 w-100">
                  <Col className="p-0 ps-lg-13 pe-3">
                    <Blockquote>
                      <div className="fw-light text-sub1 text-light-grey-normal">
                        <span>{item.note}</span>
                      </div>
                    </Blockquote>
                  </Col>
                </Row>
              )}
            </>
          ))}
        </Accordion>
      </Row>
      <Row className="m-0 mt-7">
        <Blockquote variant="warning-bg" lineVariant="warning">
          <div className="fw-light text-sub1 text-light-grey lh-xs pt-3 d-flex flex-column">
            <div className="text-sub1 text-danger-dark fw-bolder">
              <span>You're not meeting the company match of 6%.</span>
            </div>
            <div className="text-sub1 fw-light">
              <span>Don’t leave free money on the table!</span>
            </div>
          </div>
        </Blockquote>
      </Row>
    </section>
  );
};

export default InvestMyself;
